import styles from './LabelTitle.module.css'

const LabelTitle = ({required, title}) => {
  return <span className={styles.title}>{title}{required && <span className={styles.required}>*</span>}</span>
}

export default LabelTitle